import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';
import { ResolvedSectionLoader } from '../../models/loading.models';
import { LoaderRegistryService } from '../../services/loader-registry.service';

@Component({
  selector: 'app-section-loader, myt-app-section-loader',
  templateUrl: './app-section-loader.component.html',
  styleUrls: ['./app-section-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppSectionLoaderComponent {
  private readonly scopeKeySubject = new BehaviorSubject<string>('');

  readonly activeSectionLoader$: Observable<ResolvedSectionLoader | null> =
    this.scopeKeySubject.pipe(
      switchMap((scopeKey) =>
        scopeKey ? this.loaderRegistryService.selectSectionLoader(scopeKey) : of(null)
      )
    );

  readonly visibleSectionLoader$: Observable<ResolvedSectionLoader | null> =
    this.scopeKeySubject.pipe(
      switchMap((scopeKey) =>
        scopeKey
          ? this.loaderRegistryService.selectVisibleSectionLoader(scopeKey)
          : of(null)
      )
    );

  @Input()
  set scopeKey(scopeKey: string) {
    this.scopeKeySubject.next(scopeKey?.trim() ?? '');
  }

  constructor(private readonly loaderRegistryService: LoaderRegistryService) {}
}
